<script>
  import { onMount, onDestroy } from 'svelte';
  import { fly } from 'svelte/transition';

  let { onclose, children, wide = false } = $props();

  onMount( () => {
    let scrollbarWidth = window.innerWidth - document.body.offsetWidth;

    document.body.style.paddingRight = `${scrollbarWidth}px`;
    document.body.style.overflow = 'hidden';
  });

  onDestroy( () => {
    document.body.style.paddingRight = '';
    document.body.style.overflow = '';
  });
</script>


<div transition:fly={{duration: 200}} class="modal-container" class:wide>
  <div class="backdrop" onclick={onclose}></div>
  <div class="container">
    <div class="closer" onclick={onclose}>
      <svg fill="#737373" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 30 30" width="30px" height="30px">    <path d="M 7 4 C 6.744125 4 6.4879687 4.0974687 6.2929688 4.2929688 L 4.2929688 6.2929688 C 3.9019687 6.6839688 3.9019687 7.3170313 4.2929688 7.7070312 L 11.585938 15 L 4.2929688 22.292969 C 3.9019687 22.683969 3.9019687 23.317031 4.2929688 23.707031 L 6.2929688 25.707031 C 6.6839688 26.098031 7.3170313 26.098031 7.7070312 25.707031 L 15 18.414062 L 22.292969 25.707031 C 22.682969 26.098031 23.317031 26.098031 23.707031 25.707031 L 25.707031 23.707031 C 26.098031 23.316031 26.098031 22.682969 25.707031 22.292969 L 18.414062 15 L 25.707031 7.7070312 C 26.098031 7.3170312 26.098031 6.6829688 25.707031 6.2929688 L 23.707031 4.2929688 C 23.316031 3.9019687 22.682969 3.9019687 22.292969 4.2929688 L 15 11.585938 L 7.7070312 4.2929688 C 7.5115312 4.0974687 7.255875 4 7 4 z"/></svg>
    </div>
    {@render children()}
  </div>
</div>


<style>
  .modal-container {
    position: fixed;
    /* layouts put the sticky header at 100 and the mobile search bar at 105,
       and the cart ships inside all of them - stay clear of both */
    z-index: 9999;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    box-sizing: border-box;
  }

  @media (min-width: 768px) {
    .modal-container {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px;
    }
  }

  @media (min-width: 1100px) {
    .modal-container {
      padding-left: 5vw;
      padding-right: 5vw;
    }

    .modal-container.wide {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  @media (min-width: 1200px) {
    .modal-container {
      padding-left: 10vw;
      padding-right: 10vw;
    }

    .modal-container.wide {
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  @media (min-width: 1300px) {
    .modal-container {
      padding-left: 15vw;
      padding-right: 15vw;
    }

    .modal-container.wide {
      padding-left: 40px;
      padding-right: 40px;
    }
  }

  .backdrop {
    display: none;
  }

  @media (min-width: 768px) {
    .backdrop {
      display: block;
      position: fixed;
      z-index: -1;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      box-sizing: border-box;
      background-color: rgba(0, 0, 0, 0.8);
    }
  }

  .backdrop + .container {
    overflow-y: auto;
    position: relative;
    background-color: white;
    padding: 40px 20px;
    height: 100%;
  }

  @media (min-width: 768px) {
    .backdrop + .container {
      height: auto;
      min-height: 200px;
      max-height: 100%;
      padding: 40px;
      min-width: 50%;
      box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
                  0px 24px 38px 3px rgba(0, 0, 0, 0.14),
                  0px 9px 46px 8px rgba(0, 0, 0, 0.12);
    }
  }

  .closer {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
  }

  .closer svg {
    transition: color 0.3s ease-in-out;
  }

  .closer:hover svg {
    fill: black;
  }
</style>
